<h3>Plain checkbox, event listeners</h3>
<ui-toggle-switch
    label="On"
    (select)="setOnState(true)"
    [disabled]="disabled"
    [selected]="on">
</ui-toggle-switch>
<ui-toggle-switch
    label="Off"
    (select)="setOnState(false)"
    [disabled]="disabled"
    [selected]="!on">
</ui-toggle-switch>
<p>Variable 'on' is: {{ on }}</p>
<ui-button text="{{ disabled ? 'Enable' : 'Disable'}}" (click)="toggleDisabledState()"></ui-button>


<h3>Interim checkbox</h3>
<ui-toggle-switch
        label="Interim"
        [disabled]="disabled"
        [interim]="true"
        [selected]="true">
</ui-toggle-switch>

<h3>Plain checkbox (with two-way-binding)</h3>
<ui-toggle-switch
    label="Cow"
    [(selected)]="cow">
</ui-toggle-switch>
<ui-toggle-switch
    label="Chicken"
    [(selected)]="chicken">
</ui-toggle-switch>
<p>Variable 'cow' is: {{ cow }}. Variable 'chicken' is: {{ chicken }}</p>

<h3>Checkboxs in selectable list (Single select)</h3>
<ui-selectable-list
    #list
    [(selected)]="selectedOption"
    [multiSelect]="false">
    <ui-toggle-switch
        *ngFor="let option of checkboxOptions"
        [label]="option.label"
        [value]="option">
    </ui-toggle-switch>
</ui-selectable-list>
<p>
    <a (click)="list.selectAll()" class="selection" style="margin-right: 10px;">Select all</a>
    <a (click)="list.deselectAll()" class="selection">Deselect all</a>
</p>
<p>
    Variable 'selectedOption.label' is: {{ selectedOption?.label }}
</p>



<h3>Checkboxs in selectable list (Multi select)</h3>
<ui-selectable-list
    #multiList
    [(selected)]="multiSelectedOptions"
    [multiSelect]="true">
    <ui-toggle-switch
        *ngFor="let option of checkboxOptions"
        [label]="option.label"
        [value]="option">
    </ui-toggle-switch>
</ui-selectable-list>
<p>
    <a (click)="multiList.selectAll()" class="selection" style="margin-right: 10px;">Select all</a>
    <a (click)="multiList.deselectAll()" class="selection">Deselect all</a>
</p>
<p>
    Variable 'multiSelectedOptions' is: {{ multiSelectedOptions?.length }} long
</p>
